import Layout from "../components/Layout";
import Banner from "../components/Banner";
import Section from "../components/Section";
import SectionBackground from "../components/SectionBackground";
import ItemCard from "../components/ItemCard";

import bgGlass from '../res/bg_glass.jpg';
import bgWip from '../res/bg_wip.jpg';
import bgGPT4CT from '../res/problem-decomposition.png';
import bgUtilities from '../res/html.jpg';
import bgPortfolio from '../res/eggsorcist.png';
import bgLensql from '../res/database.jpg';
import bgRecipes from '../res/ragu-di-carne.jpg';
import bgSpace from '../res/bg_space.jpg';

function Home() {
    return (
        <Layout banner={<Banner />}>

            <div className="text-center">
                <SectionBackground img={bgGlass}>
                    <Section title="Content">
                        <ItemCard title="Recipes" href="/recipes" img={bgRecipes}>
                            Personal collection of recipes
                        </ItemCard>

                        <ItemCard title="Utilities" href="/utils" img={bgUtilities}>
                            Handy utilities for common tasks
                        </ItemCard>

                        <ItemCard title="Portfolio" href="/portfolio" img={bgPortfolio}>
                            Showcase of websites I developed
                        </ItemCard>

                        <ItemCard title="Travel Checklist" href="/travel-checklist" img={bgSpace}>
                            Checklist for travel preparation
                        </ItemCard>

                        <ItemCard title="D&D" href="https://dnd.ponzidav.com" img={bgSpace}>
                            Collection of tools for D&D
                        </ItemCard>
                    </Section>
                </SectionBackground>

                <SectionBackground img={bgWip}>
                    <Section title="Research">
                        <ItemCard title="LensQL" href="https://lensql.ponzidav.com" isExternal img={bgLensql}>
                            AI-powered tool for learning SQL
                        </ItemCard>

                        <ItemCard title="GPT4CT" href="https://gpt4ct.ponzidav.com" isExternal img={bgGPT4CT}>
                            Tool for problem decomposition and learning computational thought
                        </ItemCard>
                    </Section>
                </SectionBackground>

            </div>
        </Layout>
    );
}

export default Home;
